import { FC } from "react";
import ReactQuillCustomJP from "@lhd/components/ReactQuillCustomJP";
import { AppPartType } from "../../../types";
import styled from "styled-components";

const Styles = styled.div`
  .quill {
    height: 100%;
  }
`;

type Prop = {
  appPart: AppPartType;
};
const Text: FC<Prop> = ({ appPart: { default_value } }) => {
  return (
    <Styles
      style={{
        height: "100%",
      }}
    >
      <ReactQuillCustomJP readOnly value={default_value} />
    </Styles>
  );
};

export default Text;
